import React from 'react';
import PropTypes from 'prop-types';

import InputGroup from '~components/forms/inputs/Field';
import * as Yup from 'yup';

export const NameBlockSchema = {
  first_name: Yup.string().required('First name is required'),
  last_name: Yup.string().required('Last name is required'),
};

function NameBlock({ errors, required }) {
  return (
    <div className='space-y-5'>
      <InputGroup
        name='first_name'
        label='First name'
        errors={errors}
        required={required}
      />
      <InputGroup
        name='last_name'
        label='Last name'
        errors={errors}
        required={required}
      />
    </div>
  );
}

NameBlock.propTypes = {
  errors: PropTypes.object.isRequired,
  required: PropTypes.bool,
};

export default NameBlock;
